import React, {Component} from "react";
import PropTypes from "prop-types";
import {PopupEditor as PopupEditorInternal} from "@mnjsplatform/components/lib/common/PopupEditor/PopupEditor";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {CommandContext} from "@mnjsplatform/data";
import Instruction from "./Instruction";
import {connect} from "react-redux";
import reactToText from "react-to-text";

class PopupEditor extends Component {
    static contextType = CommandContext;

    constructor(props) {
        super(props);
        this.state = {
            settings: null
        }
    }

    componentDidMount() {
        this.initialize()
    }

    initialize = async () => {
        /*Ключ:
            WorkSiteId – идентификатор РМ
            CommandItemId – идентификатор команды в РМ
            PlaceholderId – идентификатор фрейма в команде
            PlaceholderName – наименование фрейма*/
        const menuItem = this.props.menuId ? this.props.menuItems.find(mi => mi.MenuID === this.props.menuId)
            : this.props.menuItems.find(mi => mi.AppCommand && mi.AppCommand.Param1 === this.context.key);
        this.command = menuItem?.AppCommand;
        this.placeholderId = this.props.instructionId || "POPUP_EDITOR";
        const cleanTitle = reactToText(this.props.title);
        let title = this.props.staticTitle || cleanTitle || this.props.title;
        if (this.props.getTitle) {
            title = this.props.getTitle();
        }

        this.key = {
            WorkSiteId: this.context.workplaceId,
            CommandItemId: this.command.ID,
            PlaceholderId: this.placeholderId,
            PlaceholderName: title
        };
        await this.props.dispatch(this.props.dataItemInfo.reset());
        await this.props.dispatch(this.props.dataItemInfo.execute(this.key));
        this.setState({settings: this.props.dataItemInfo.getRow(0)})
    }

    render() {
        if (!this.props.visible)
            return null;
        if (!this.state.settings) {
            return null;
        }
        if (this.state.settings["IsPlaceholderVisible"] != null && this.state.settings["IsPlaceholderVisible"] !== 1) {
            return null;
        }
        const customTitle = this.state.settings["PlaceholderNameUser"] || this.props.title;
        return (<PopupEditorInternal {...this.props} title={customTitle}>
                {this.props.showInstruction && this.command &&
                    <Instruction instructionId={this.props.instructionId} {...this.state.settings}/>}
                {this.props.children}
            </PopupEditorInternal>
        );
    }
}

PopupEditor.propTypes = {
    dispatch: PropTypes.func,
    dataItem: PropTypes.object,
    rowIndex: PropTypes.number,
    visible: PropTypes.bool,
    readOnly: PropTypes.bool,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    saveButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    onParamRender: PropTypes.func,
    usePortal: PropTypes.bool,
    style: PropTypes.object,
    maxWidthBody: PropTypes.string,
    showInstruction: PropTypes.bool,
    staticTitle: PropTypes.string,
    instructionId: PropTypes.string,
    dataItemInfo: PropTypes.object,
    menuId: PropTypes.number,
    getTitle: PropTypes.func,
    children: PropTypes.node,
    menuItems: PropTypes.array
};

PopupEditor.defaultProps = {
    rowIndex: 0,
    readOnly: true,
    onParamRender: paramRender,
    usePortal: true,
    showInstruction: true
};

function mapStateToProps(state) {
    return {
        menuItems: state.appState.appParams.menu.Items,
        dataItemInfo: state.instructionState.PersOffHelp_GetHelpForPO
    };
}

export default connect(mapStateToProps)(PopupEditor);